current_url = new URL(window.location.href);
if (current_url.searchParams.has('hci')) {
    var info_id = current_url.searchParams.get('hci');
    var url = "https://app.hiddencontact.com/ref/shop/info/" + info_id
    fetch(url).then(function (response) {
        if (response.ok) {
            return response.text();
        }
        throw response;
    }).then(function (body) {
            var prefix = "<div class=\"md-modal md-show\" id=\"hc-modal\"><div class=\"md-content\" style=\"background:#ffffff;\"><div class=\"md-body\"><div style=\"text-align:right; margin-right: 15px;\"><a href=\"#\" onclick=\"document.getElementById('hc-modal').classList.remove('md-show');return false;\"><svg width=\"10\" viewBox=\"0 0 10 10\"><path d=\"M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z\" fill=\"#A1A1A1\" fill-rule=\"nonzero\"></path></svg></a></div>";
            var suffix = "</div></div></div>";
            var content = prefix + body + suffix;
            document.body.insertAdjacentHTML("beforeend", content)
    });
}
// Getting the current URL pathname
var pathname = window.location.pathname;

// Checking if the current URL starts with "/msg/"
if (pathname.startsWith("/msg/")) {
    // If it does, then we extract the part of URL after "/msg/"
    var extractedPart = pathname.slice(5); // 5 is length of "/msg/"

    // Then we redirect
    window.location.href = "https://hiddencontact.com/msg/" + extractedPart;
}

// Check if privacy policy is requested and load content from app in that case
if (window.location.href.includes("policies/privacy-policy")) {
    const lang = navigator.language;
    fetch('https://app.hiddencontact.com/privacy/policy?lang=' + lang)
    .then(response => response.text())
    .then(html => { document.getElementById('privacy-policy').innerHTML = html; });
}